import axios from "axios";
import React, {useCallback, useEffect, useState} from "react";
import { ReactComponent as IcSave } from "../../../../../Assets/Images/Save.svg";
import { ReactComponent as IcSaved } from "../../../../../Assets/Images/Saved.svg";
import { Config } from "../../../../../Config";

const JpaCard = (props) => {
  const [IsApplied, setIsApplied] = useState(props.jpa.applied || !!props.jpa.application?.id);
  const [RevealIdentity, setRevealIdentity] = useState(props.jpa.revealIdentity || props.jpa.application?.revealIdentity)
  // we need to trigger different API when doing action for ShowMe.
  // ShowMe is judge whether the key 'application' exist in props.jpa.
  const isShowMe = 'application' in props.jpa
  const [IsSaved, setIsSaved] = useState(props.jpa.bookmarked);
  const [ReactionType, setReactionType] = useState(props.jpa.reactionType) //NULL, DISLIKE, LIKE

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleJpaApply = (IsAnonymous) => {
    let ReqURL =
      Config.PositionServiceURL +
      (isShowMe ? "/api/position/application" : "/api/position/chatbot-recommendation/application");
    if (props.JPAType === "project") {
      ReqURL =
        Config.ProjectServiceURL +
        (isShowMe ? "/api/project/application" : "/api/project/chatbot-recommendation/application");
    } else if (props.JPAType === "activity") {
      ReqURL =
        Config.ActivityServiceURL +
        (isShowMe ? "/api/activity/application" : "/api/activity/chatbot-recommendation/application");
    }
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        id: props.jpa.main_id,
        recommendationId: props.jpa.main_id,
        isAnonymous: IsAnonymous,
        type: IsAnonymous ? "ANONYMOUS" : "DEFAULT"
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setIsApplied(Res.data.applied);
        setRevealIdentity(!IsAnonymous)
        //no need to refresh recommendation
        if (isShowMe) {
          setIsApplied(!!Res.data.application?.id)
          setRevealIdentity(Res.data.application?.revealIdentity)
          return
        }
        props.RefreshRecommendations();
      })
      .catch((Err) => {
        console.log(Err.response);
        const {data, status} = Err.response
        if (status === 409 && data?.key === "duplicate_error") {
          setIsApplied(true);
        }
      });
  };

  const handleSave = () => {
    let ReqURL =
      Config.PositionServiceURL +
      (isShowMe ?
          "/api/position/recommendation/bookmark" :
          "/api/position/chatbot-recommendation/bookmark");
    if (props.JPAType === "project") {
      ReqURL =
        Config.ProjectServiceURL +
        (isShowMe ?
            "/api/project/recommendation/bookmark" :
            "/api/project/chatbot-recommendation/bookmark");
    } else if (props.JPAType === "activity") {
      ReqURL =
        Config.ActivityServiceURL +
        (isShowMe ?
            "/api/activity/recommendation/bookmark" :
            "/api/activity/chatbot-recommendation/bookmark");
    }
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        id: props.jpa.main_id,
        [`${props.JPACategoryType.toLowerCase()}RecommendationId`] : props.jpa.main_id,
        recommendationId: props.jpa.main_id
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setIsSaved(Res.data.bookmarked);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const toggleDislike = () => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "DISLIKE",
    };

    if (props.JPAType.toLowerCase() === "project") {
      ActionURL = Config.ProjectServiceURL;
      ActionType = props.JPAType.toLowerCase();
      Data.id = props.jpa.main_id;
      Data[`${ActionType}RecommendationId`] = props.jpa.main_id
    } else if (props.JPAType.toLowerCase() === "activity") {
      ActionURL = Config.ActivityServiceURL;
      ActionType = props.JPAType.toLowerCase();
      Data.id = props.jpa.main_id;
      Data[`${ActionType}RecommendationId`] = props.jpa.main_id
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.id = props.jpa.main_id;
      Data[`${ActionType}RecommendationId`] = props.jpa.main_id
    }

    let Req = {
      method: "POST",
      baseURL:
          window._env_.API_URL +
          ActionURL +
          "/api/" +
          ActionType +
          (isShowMe ? '/recommendation/reaction' :
          "/chatbot-recommendation/reaction"),
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
        .then((Res) => {
          setReactionType(Res.data.reactionType)
        })
        .catch((Err) => {
          console.log(Err.response);
        });
  }

  const toggleLike = () => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "LIKE",
    };

    if (props.JPAType.toLowerCase() === "project") {
      ActionURL = Config.ProjectServiceURL;
      ActionType = props.JPAType.toLowerCase();
      Data.id = props.jpa.main_id;
      Data[`${ActionType}RecommendationId`] = props.jpa.main_id
    } else if (props.JPAType.toLowerCase() === "activity") {
      ActionURL = Config.ActivityServiceURL;
      ActionType = props.JPAType.toLowerCase();
      Data.id = props.jpa.main_id;
      Data[`${ActionType}RecommendationId`] = props.jpa.main_id
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.id = props.jpa.main_id;
      Data[`${ActionType}RecommendationId`] = props.jpa.main_id
    }

    let Req = {
      method: "POST",
      baseURL:
          window._env_.API_URL +
          ActionURL +
          "/api/" +
          ActionType +
          (isShowMe ? '/recommendation/reaction' :
              "/chatbot-recommendation/reaction"),
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
        .then((Res) => {
          setReactionType(Res.data.reactionType)
        })
        .catch((Err) => {
          console.log(Err.response);
        });
  }

  const shortenTitle = (Title) => {
    if (Title !== undefined) {
      if (Title.length <= 35) {
        return Title;
      } else {
        let Short = Title.slice(0, 35) + " ...";
        return (
          <>
            <p className="popup-text">{Title}</p>
            {Short}
          </>
        );
      }
    }
  };

  const shortenLocation = (Loc) => {
    if (Loc !== undefined) {
      if (Loc.length <= 12) {
        return Loc;
      } else {
        let Short = Loc.slice(0, 8) + " ...";
        return (
          <>
            <p className="popup-text">{Loc}</p>
            {Short}
          </>
        );
      }
    }
  };

  useEffect(() => {
    setIsApplied(props.jpa.applied||!!props.jpa.application?.id)
    setIsSaved(props.jpa.bookmarked)
    setReactionType(props.jpa.reactionType)
    setRevealIdentity(props.jpa.revealIdentity || props.jpa.application?.revealIdentity)
  }, [props.jpa]);

  useEffect(() => {
    if (props.ChangedJPAReaction.id === props.jpa.id) {
      setReactionType(props.ChangedJPAReaction.reactionType)
      setIsSaved(props.ChangedJPAReaction.isBookmarked)
    }
  }, [props.ChangedJPAReaction])

  return (
    <div className="jpa-card">
      <div className="frame-top">
        <div className="jpa-profile">
          <p className="jpa-profile-title">{shortenTitle(props.jpa.title)}</p>
          <p className="jpa-profile-city">
            {shortenLocation(props.jpa.workCity)}
          </p>
        </div>
        <div className="jpa-save">
          <button
              onClick={() => toggleDislike()}
              className={`rounded ${ReactionType === 'DISLIKE' && 'active'}`}>
            <i className="feather-thumbs-down"></i>
          </button>
          <button
              onClick={() => toggleLike()}
              className={`rounded ${ReactionType === 'LIKE' && 'active'}`}>
            <i className="feather-thumbs-up"></i>
          </button>
          {IsSaved ? (
            <IcSaved className="jpa-save-btn" onClick={() => handleSave()} />
          ) : (
            <IcSave className="jpa-save-btn" onClick={() => handleSave()} />
          )}
        </div>
      </div>
      <div className="frame-bottom">
        <button
          className={
            IsApplied ? "jpa-apply-btn jpa-apply-btn-disabled" : "jpa-apply-btn"
          }
          onClick={() => handleJpaApply(false)}
        >
          {IsApplied
            ? <span className="jpa-apply-btn-content">
                {RevealIdentity ? <i className='feather-check'/> : null}
                {translateText("jpa_status_applied")}
              </span>
            : translateText("apply")}
        </button>
        <button
          className={
            IsApplied ? "jpa-apply-btn jpa-apply-btn-disabled" : "jpa-apply-btn"
          }
          onClick={() => handleJpaApply(true)}
        >
          {IsApplied
            ? <span className="jpa-apply-btn-content">
                {!RevealIdentity ? <i className='feather-check'/> : null}
                {translateText("applied_anonymously")}
              </span>
            : translateText("anonymous_apply")}
        </button>
        <div
          className="jpa-more-details"
          onClick={() => props.SetDetailsIsOpen(true, props.jpa)}
        >
          {translateText("more_details")}
        </div>
      </div>
    </div>
  );
};

export default JpaCard;
